import Prism from 'prismjs'
import 'prismjs/themes/prism-okaidia.css'
export default Prism
